import { render, staticRenderFns } from "./MarketNews.vue?vue&type=template&id=6bcf778a&scoped=true"
import script from "./MarketNews.vue?vue&type=script&lang=js"
export * from "./MarketNews.vue?vue&type=script&lang=js"
import style0 from "./MarketNews.vue?vue&type=style&index=0&id=6bcf778a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcf778a",
  null
  
)

export default component.exports